module.exports = __webpack_public_path__ + "assets/img/smartTV-module4-1.fff85434.jpg";